import React from 'react';
import RequestSuccessDF from '../components/SimulatorsComponents/DefualtSimulators/RequestSuccessDF';
import { Android, split_payment_successful } from '../utils/DictionaryManagementUtils';
import { img_android_screen_success, scr_success } from '../utils/ImagesManagementUtils';
//= ========================================================================
const Sim_G12_SplitPaymentSuccess = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <RequestSuccessDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
    showOnlyFirstSim
    normalBackgroundImage={simPlatform === Android ? img_android_screen_success : scr_success}
    largeText={split_payment_successful}
    isShareRecipt
  />
);

export default Sim_G12_SplitPaymentSuccess;
